import React from 'react';

function AccessModal({ accessData, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 bg-black/30 backdrop-blur-sm">
      <div className="w-full max-w-xl p-6 bg-white rounded-lg">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-800">User Access</h3>
          <button
            className="flex items-center justify-center w-8 h-8 text-2xl text-gray-500 transition duration-200 bg-gray-200 rounded-full hover:bg-gray-300 hover:text-gray-800"
            onClick={onCancel}
          >
            &times;
          </button>
        </div>
        <div className="mb-4">
          {accessData.length === 0 ? (
            <p className='flex  justify-center text-[#212121] text-[16px] font-[Inter] font-[500]'>No access granted</p>
          ) : (
            <ul className='grid grid-cols-1 gap-3 lg:grid-cols-2'>
              {accessData.map((item, index) => (
                <li key={index} className="bg-[#715EFE33]/10 text-[#212121] text-[14px] font-[Inter] font-[500] px-3 py-1.5 rounded-md inline-block capitalize">
                  {item.replace(/_/g, ' ')}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default AccessModal;
